import { render, staticRenderFns } from "./ResumeDetailContent.vue?vue&type=template&id=317ef936&scoped=true&"
import script from "./ResumeDetailContent.vue?vue&type=script&lang=js&"
export * from "./ResumeDetailContent.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/resume_detail.css?vue&type=style&index=0&id=317ef936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317ef936",
  null
  
)

export default component.exports